module.exports = __webpack_public_path__ + "media/images/step3-a1e97c1c8b5cd077b9746d791ae088c5.png";